import { ErrorMessage, useFormikContext } from 'formik'
import DropdownIcon from 'icon/dropdown'
import React from 'react'
import { control, label as labelStyle, error as errorStyle } from 'theme/ui'

export default function Select({
  name,
  placeholder,
  label,
  options = [],
  onSelect,
  value,
  className, // Add className prop here
  required,
}) {
  const formik = useFormikContext()
  const inputProps = name ? formik.getFieldProps(name) : {}
  return (
    <>
      {label ? (
        <label htmlFor={name} className={labelStyle}>
          {label || ''}
          {required ? ' *' : ''}
        </label>
      ) : (
        ''
      )}
      <div className='relative w-full'>
        <div className='absolute end-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted'>
          <DropdownIcon />
        </div>
        <select
          value={value}
          onChange={onSelect}
          placeholder={placeholder || ''}
          {...inputProps}
          id={name}
          // studio select (plans/REDESIGN.md, phase 1)
          className={`${control} truncate pe-9 appearance-none ${className || ''}`}
        >
          <option disabled selected value={''}>
            {' '}
            {placeholder || 'Select option'}
          </option>
          {options?.map((option) => (
            <option disabled={option.disabled} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {name && (
          <ErrorMessage
            name={name || ''}
            component={'div'}
            className={errorStyle}
          />
        )}
      </div>
    </>
  )
}
